import { render, staticRenderFns } from "./PurchasingPaymentGroupList.vue?vue&type=template&id=8bfb0a02&"
import script from "./PurchasingPaymentGroupList.vue?vue&type=script&lang=js&"
export * from "./PurchasingPaymentGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports